// webpack configuration
import { environment } from '../../environments/environment'

export class Constants {
    private static constantsSingleton: Constants
    API_URL: string
    REV_URL: string
    VERSION_URL: string
    VERSION: string
    BUILD_FOR_BROWSER: boolean
    BUILD_FOR_MOBILE: boolean
    DEVELOPMENT_BUILD: boolean
    ENVIRONMENT: string
    IS_MOBILE_BROWSER: boolean

    static getConstantsSingleton(): Constants {
        if (!Constants.constantsSingleton) {
            Constants.constantsSingleton = new Constants()
        }

        return Constants.constantsSingleton
    }

    private constructor() {
        this.IS_MOBILE_BROWSER = this.checkIfMobileDevice()
        this.API_URL = environment.API_URL
        this.REV_URL = environment.REV_URL
        this.VERSION_URL = environment.VERSION_URL
        this.VERSION = environment.VERSION
        this.BUILD_FOR_BROWSER = environment.BUILD_FOR_BROWSER
        this.BUILD_FOR_MOBILE = environment.BUILD_FOR_MOBILE
        this.DEVELOPMENT_BUILD = environment.DEVELOPMENT_BUILD
        this.ENVIRONMENT = environment.ENVIRONMENT
    }

    private checkIfMobileDevice = (): boolean =>
        !!(
            navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
        )
}
